import { mobile, tablet } from "components/templates/Breakpoints";
import { H1 as _H1 } from "components/atoms/Heading";
import React from "react";
import { types } from "react-bricks/frontend";
import styled from "styled-components";
import { backgroundColorProp } from "../utils/backgroundColor";
import { Repeater } from "react-bricks";
import { HeroLeftTextProps } from "./HeroLeftText";
import { FIELD_PRESETS } from "../forms/util";

interface HeroFormProps {
  backgroundColor?: types.IColor;
  leftText?: types.RepeaterItems<HeroLeftTextProps>;
}

const HeroForm: types.Brick<HeroFormProps> = ({ backgroundColor }) => {
  return (
    <Container backgroundColor={backgroundColor?.color}>
      <Left>
        <Repeater propName="leftText" />
      </Left>
      <Right>
        <Repeater propName="form" />
      </Right>
    </Container>
  );
};

HeroForm.schema = {
  name: "hero-form",
  label: "Hero Landing (Form)",
  previewImageUrl: "/static/bricks/hero-form.png",
  repeaterItems: [
    {
      name: "leftText",
      itemType: "hero-left-text",
      itemLabel: "Copy",
      min: 1,
      max: 1,
    },
    {
      name: "form",
      itemType: "hubspot-form",
      itemLabel: "Form",
      min: 1,
      max: 1,
    },
  ],

  // Defaults when a new brick is added
  getDefaultProps: () => ({
    leftText: [
      {
        title: "Title to describe what the webinar is about to go here here here what",
        body: "Supporting copy here",
        topImageWidth: 170,
        showBody: true,
        showBottomImage: true,
        showTopImage: true,
      },
    ],
    form: [
      {
        fields: [
          FIELD_PRESETS.EMAIL,
          FIELD_PRESETS.FIRST_NAME,
          FIELD_PRESETS.LAST_NAME,
          FIELD_PRESETS.COMPANY_NAME,
          FIELD_PRESETS.JOB_TITLE,
          FIELD_PRESETS.NO_OF_EMPLOYEES,
          FIELD_PRESETS.PHONE_NUMBER,
        ],
        hubspotFormId: "getInTouch",
        redirectUrl: "/form/success",
      },
    ],
  }),

  // Sidebar Edit controls for props
  sideEditProps: [backgroundColorProp],
};

export default HeroForm;

const Container = styled.div<{ backgroundColor: string }>`
  background: ${(p) => p.backgroundColor};
  max-width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;
  padding: 9rem 6rem 8rem 6rem;

  ${tablet} {
    flex-direction: column;
    padding: 4rem;
  }

  ${mobile} {
    padding: 0.5rem;
  }
`;

const Left = styled.div`
  width: 55%;
  max-width: 40rem;
  margin-right: 3rem;
  margin-top: -20rem;
  ${tablet} {
    width: 100%;
    margin-bottom: 4rem;
    margin-right: 0rem;
    margin-top: 0rem;
    img {
      max-width: 100%;
    }
  }
`;

const Right = styled.div`
  width: 45%;
  max-width: 40rem;

  ${tablet} {
    width: 100%;
  }
`;
